import {
	defineRoutes,
} from '../../helpers'

export const authRoutes = defineRoutes({
	/*
	[AppRoutes.SIGN_IN]: {
		path:      AppRouterKeys.SIGN_IN,
		element:   <SignInPage />,
		guestOnly: true,
	},
	[AppRoutes.SIGN_UP]: {
		path:      AppRouterKeys.SIGN_UP,
		element:   <SignUpPage />,
		guestOnly: true,
	},
	*/
})
